<template>
    <b-alert
        :key="dialog"
        v-model="dialog"
        class="were-changes-alert"
        variant="warning"
        dismissible
    >
        There are unsaved changes!
        <button
            type="button"
            class="btn btn-warning waves-effect waves-light"
            @click="$emit('save')"
        >
            <i class="fas fa-save" />
            Save
        </button>
    </b-alert>
</template>

<script>
export default {
    props: {
        wereChanges: {
            type: Boolean,
            required: true
        }
    },

    data: () => ({
        dialog: false
    }),

    watch: {
        wereChanges() {
            this.dialog = this.wereChanges;
        }
    }
};
</script>
